import { createSelector } from 'reselect';
import { IReduxState } from '../redux/redux.interface';

export const refDataState = (state: IReduxState) => state.refData;

export const getRefDataState = createSelector(
  [refDataState],
  (refData) => refData
);
